import React from "react";

export default () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.736.4v4H20.6m0 18.384c0 .437-.342.8-.764.8H4.146c-.421 0-.76-.363-.76-.8V1.205c0-.436.339-.805.76-.805h12.59c.201 0 .294.09.437.235l3.199 3.269c.145.148.228.285.228.496v18.384zm-3.263-11.21H6.638M17.337 14.5H6.638m10.699 2.982H6.638m6.388-9.112H6.638"
      stroke="#4A4A4A"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);
